import {Website} from "../layouts/Website";
import {Box, CircularProgress, Container, Typography, useMediaQuery, useTheme} from "@mui/material";
import {PageTitle} from "../components/shared/PageTitle";

import {cardsData} from "../data/cards";
import React, {useEffect, useState} from "react";

import {Download} from "@mui/icons-material";

import qr from "../assets/images/qr_dummy.jpg";
import {CustomButton, SmallCustomButton} from "../assets/mui-styles/styles";

import {hotelsData} from "../data/hotels";
import axios from "axios";
import {API_URL} from "../config";
import {getAuthToken} from "../functions/getAuthToken";

// TODO: gestire hotel dinamico (hotelsData[campoDinamico])

export const AreaPersonale = () => {
    const [loading, setLoading] = React.useState(true)
    const [userInfo, setUserInfo] = React.useState([])
    const [error, setError] = React.useState(null)

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleTeamDownload = () => {
        const link = document.createElement('a');
        link.href = cardsData[userInfo.squadraSmorfia]; // your image source
        link.download = 'team_card.png'; // desired name for the downloaded file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleQRDownload = () => {
        const link = document.createElement('a');
        link.href = userInfo.qrCodeUrl; // your image source
        link.download = 'qr.png'; // desired name for the downloaded file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        getUserInfo()
    }, [])

    const getUserInfo = async () => {
        setLoading(true)
        let token = await getAuthToken()
        await axios.get(`${API_URL}profile`,{headers: {Authorization: token}})
            .then(res => {
                //console.info(res.data);
                setUserInfo(res.data);
                console.info(userInfo.hotel)
            })
            .catch(err => {
                // TODO : GESTIRE ERRORE
                //console.info(err.response.data.error);
                setError(true);
            })
        setLoading(false)
    }

    return (
        <Website>
            <Container sx={{pb: 2, pt: 6}}>
                <PageTitle title={'AREA PERSONALE'} image={'icon-area-personale'}/>
                {loading ?
                    <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', height:'100%'}}>
                        <CircularProgress></CircularProgress>
                    </Box>
                    :
                    <>
                        <Box>
                            <Typography sx={{color: '#d2202e'}} fontSize={'22px'}>
                                IL MIO ITINERARIO
                            </Typography>
                            <ul>
                                {userInfo.documentazione &&
                                    <li>
                                        <a href={userInfo.documentazione} target="_blank">Documentazione completa</a>
                                    </li>
                                }
                                {/*{userInfo.bigliettoAndataRitorno &&
                                    <li>
                                        <a href={userInfo.bigliettoAndataRitorno} target="_blank">Biglietteria</a>
                                    </li>
                                }
                                {userInfo.avvicinamentoAndata === 'MEZZI PROPRI' &&
                                    <li>
                                        <p>MEZZI PROPRI</p>
                                    </li>
                                }
                                {userInfo.avvicinamentoAndata === 'TRANSFER NAPOLI - SORRENTO A/R' &&
                                    <li>
                                        <p>TRANSFER NAPOLI - SORRENTO A/R</p>
                                    </li>
                                }
                                {userInfo.avvicinamentoAndata === 'NO' &&
                                    <li>
                                        <p>IN AUTONOMIA</p>
                                    </li>
                                }*/}
                            </ul>
                            <Box sx={{py: 2}}>
                                <Box sx={{borderBottom: '3px solid #e63023', width: '4rem', marginLeft: '3rem'}}/>
                            </Box>
                        </Box>
                        <Box>
                            <Typography sx={{color: '#d2202e'}} fontSize={'22px'} mb={2}>
                                IL MIO HOTEL
                            </Typography>
                            <Box sx={{display: 'flex', flexDirection:isMobile ? 'column' : 'row'}}>
                                <img style={{
                                    width:isMobile ? '100%' : '20vw',
                                    height:'auto',
                                    marginRight: '10px'
                                }}
                                     src={'/images/hotel/hotel-img.jpg'} alt={''}
                                />
                                <div style={{
                                    display: "flex",
                                    flexDirection: 'column',
                                    alignItems: 'left',
                                    justifyContent: 'flex-start',
                                    fontFamily:'Arial'
                                }}>
                                    <h3 style={{
                                        color: '#d2202e',
                                        borderLeft: '3px solid #e63023',
                                        margin: 0,
                                        paddingLeft: '5px',
                                        fontFamily:'Arial B',
                                        paddingTop:'5px',
                                        paddingBottom:'5px',
                                        marginTop: isMobile ? '15px' : '0px',
                                        marginBottom:'15px'
                                    }}>
                                        KENZI MENARA PALACE 5*
                                    </h3>
                                    <p style={{marginTop: 0, marginBottom: 5, }}><span
                                        style={{fontWeight: 'bold'}}>Indirizzo</span>: Zone de l’Agdal, Bd Mohamed VI, Marrakesh 40000, Marocco </p>
                                    <p style={{marginTop: 0, marginBottom: 5}}>
                                        <span style={{fontWeight: 'bold'}}>Tel</span>: +212 5244-59900
                                    </p>
                                    <p style={{marginTop: 0, marginBottom: 0}}>
                                        <span style={{fontWeight: 'bold'}}>Sito web</span>:  <a href={'https://www.kenzi-hotels.com/kenzi-menara-palace/'} target="_blank">www.kenzi-hotels.com/kenzi-menara-palace</a>
                                    </p>

                                    <br/>

                                    <p style={{marginTop: 0, marginBottom: 5}}><span
                                        style={{fontWeight: 'bold'}}>Accomodation</span>: camera doppia uso singola (include i seguenti servizi: colazione, wi-fi, palestra, piscina esterna)
                                    </p>
                                    <p style={{marginTop: 0, marginBottom: 5}}><span style={{fontWeight: 'bold'}}>Check-in</span>: {userInfo.hotelCheckIn ? new Date(userInfo.hotelCheckIn).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }) : ' / '} </p>
                                    <p style={{marginTop: 0, marginBottom: 5}}><span
                                        style={{fontWeight: 'bold'}}>Check-out</span>:  {userInfo.hotelCheckOut ? new Date(userInfo.hotelCheckOut).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }) : ' / '}
                                    </p>
                                    <p style={{marginTop: 0, marginBottom: 5}}><span
                                        style={{fontWeight: 'bold'}}>Extra</span>: {userInfo.extra ? userInfo.extra : ' / '} </p>
                                </div>
                            </Box>
                            <Box sx={{py:2}}>
                                <Box sx={{borderBottom:'3px solid #e63023', width:'4rem', marginLeft:'3rem'}}/>
                            </Box>
                        </Box>
                    </>
                }
            </Container>
        </Website>
    )
}